export const BUTTON_ROWS_FORM_KEY = 'buttonRows';

export const TELEGRAM_MAX_UPLOAD_SIZE_IN_BYTES = 5242880; // 5 MB
export const TELEGRAM_MAX_UPLOAD_SIZE_IN_MEGABYTES = TELEGRAM_MAX_UPLOAD_SIZE_IN_BYTES / (1024 * 1024);
